import {createSlice} from "@reduxjs/toolkit";

const initialAccessState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    accessForEdit: undefined,
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
}

export const accessesSlice = createSlice({
    name: "accesses",
    initialState: initialAccessState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // getAccessById
        accessFetched: (state, action) => {
            state.actionsLoading = false;
            state.accessForEdit = action.payload.accessForEdit;
            state.error = null;
        },
        // findAccess | getAllAccess
        accessesFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        // createAccess
        accessCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(action.payload.access);
        },
        // updateAccess
        accessUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.map(entity => {
                if (entity.id === action.payload.access.id) {
                    return action.payload.access;
                }
                return entity;
            })
        },
        // deleteAccess
        accessDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        }

    }
})